import { useEffect, useRef, useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  VStack,
} from '@chakra-ui/react';
import EmployeesApi from '../../../api/employees';
import { getCompanies } from '../../../functions/companiesCache';
import ShiftDebuggerResultsModal from './ShiftDebuggerResultsModal';

const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export default function ShiftDebuggerModal({ isOpen, onClose }) {
  const [companies, setCompanies] = useState({});
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [showResults, setShowResults] = useState(false);

  const [phone, setPhone] = useState('');
  const [govId, setGovId] = useState('');
  const [uid, setUid] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [month, setMonth] = useState(currentMonth());

  const phoneRef = useRef(null);

  useEffect(() => {
    getCompanies().then(setCompanies).catch(() => {});
  }, []);

  useEffect(() => {
    if (isOpen) {
      setPhone('');
      setGovId('');
      setUid('');
      setCompanyId('');
      setMonth(currentMonth());
      setResult(null);
      setTimeout(() => phoneRef.current?.focus(), 100);
    }
  }, [isOpen]);

  const canSubmit = companyId && (phone || govId || uid);

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    try {
      const res = await EmployeesApi.debugShifts({
        phone: phone || undefined,
        govId: govId || undefined,
        uid: uid || undefined,
        companyId: Number(companyId),
        month: month || undefined,
      });
      setResult(res.data);
      onClose();
      setShowResults(true);
    } catch (e) {
      alert(`שגיאה: ${e?.response?.data?.message || e.message}`);
    } finally {
      setLoading(false);
    }
  };

  const sortedCompanies = Object.entries(companies)
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'he'));

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton position="absolute" left="8px" right="auto" top="8px" />
          <ModalHeader>בדיקת משמרות לעובד</ModalHeader>
          <ModalBody pb={4}>
            <VStack spacing={4} align="stretch">
              <FormControl isRequired>
                <FormLabel>חברה</FormLabel>
                <Select
                  placeholder="בחר חברה..."
                  value={companyId}
                  onChange={(e) => setCompanyId(e.target.value)}
                >
                  {sortedCompanies.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name} ({c.id})
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>מספר טלפון</FormLabel>
                <Input
                  ref={phoneRef}
                  placeholder="0521234567"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  type="tel"
                />
              </FormControl>

              <FormControl>
                <FormLabel>תעודת זהות / govId</FormLabel>
                <Input
                  placeholder="123456789"
                  value={govId}
                  onChange={(e) => setGovId(e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>מספר עובד / integrationUid (אופציונלי)</FormLabel>
                <Input
                  placeholder="ABC123"
                  value={uid}
                  onChange={(e) => setUid(e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>חודש לבדיקה</FormLabel>
                <Input
                  type="month"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} mr={3} variant="ghost">ביטול</Button>
            <Button
              variant="blue"
              isLoading={loading}
              isDisabled={!canSubmit}
              onClick={handleSubmit}
            >
              בדוק
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {result && (
        <ShiftDebuggerResultsModal
          isOpen={showResults}
          onClose={() => setShowResults(false)}
          data={result}
        />
      )}
    </>
  );
}
